




import { Component, Vue } from 'vue-property-decorator';
import CreateMandate from '@/components/bankAccount/create/CreateMandate.vue';

@Component({
  name: 'create-mandate-view',
  components: {
    CreateMandate,
  },
})
export default class CreateMandateView extends Vue { }
